<template>
  <el-dialog
    title="查看领取详情"
    :visible.sync="visible"
    width="500px"
    :show-close="false"
    custom-class="claimDetailDialog"
  >
    <span slot="title" class="dialog-title">
      <span class="dialog-title-text">查看领取详情</span>
      <img
        class="custom-close"
        src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
        @click="close"
        alt="关闭"
        title="关闭"
      />
    </span>
    <div class="claim-detail-content">
      <!-- 汇总信息 -->
      <div class="claim-summary" v-if="summary.count || summary.totalAmount">
        已领取{{ summary.claimedCount || 0 }}/{{ summary.totalCount || 0 }}个，共{{ summary.claimedAmount || 0 }}/{{ summary.totalAmount || 0 }}元
      </div>
      <!-- 领取列表 -->
      <div class="claim-list">
        <div class="claim-item" v-for="(item, index) in list" :key="index">
          <div class="claim-item-avatar">
            <img v-if="item.avatar" :src="item.avatar" alt="头像" />
            <div class="avatar-placeholder" v-else>头像</div>
          </div>
          <div class="claim-item-info">
            <div class="claim-item-name">{{ item.nickname || 'XXXX' }}</div>
            <div class="claim-item-time">{{ item.grabTime }}</div>
          </div>
          <div class="claim-item-amount">¥{{ item.amount || 0 }}</div>
        </div>
      </div>
      <!-- 暂无数据提示 -->
      <div class="no-data" v-if="list.length === 0">
        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg" alt="暂无数据" />
        <p>暂无领取记录</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ClaimDetailDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    summary: {
      type: Object,
      default: () => ({
        claimedCount: 0,
        totalCount: 0,
        claimedAmount: 0,
        totalAmount: 0
      })
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('close');
    },
    handleUpdateDialogVisible(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped>
// 弹窗头部样式
.claimDetailDialog {
  :deep(.el-dialog__header) {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
  }

  :deep(.el-dialog__body) {
    padding: 0;
  }

  :deep(.el-dialog__footer) {
    padding: 0;
  }
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  .dialog-title-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .custom-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
}
.claim-detail-content {
  padding: 10px 0;
}

.claim-summary {
  background: #f5f7fa;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.claim-list {
  max-height: 400px;
  overflow-y: auto;
}

.claim-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.claim-item-avatar {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    background: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
  }
}

.claim-item-info {
  flex: 1;
  min-width: 0;
}

.claim-item-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}

.claim-item-time {
  font-size: 12px;
  color: #999;
}

.claim-item-amount {
  font-size: 16px;
  color: #f56c6c;
  font-weight: 600;
  margin-left: 12px;
}

.no-data {
  text-align: center;
  padding: 40px 0;

  img {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
  }

  p {
    color: #999;
    font-size: 14px;
    margin: 0;
  }
}
</style>
